/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Verification } from './Verification';
import {
    VerificationFromJSON,
    VerificationFromJSONTyped,
    VerificationToJSON,
    VerificationToJSONTyped,
} from './Verification';

/**
 * 
 * @export
 * @interface TaxId
 */
export interface TaxId {
    /**
     * Two-letter ISO country code for the tax ID
     * @type {string}
     * @memberof TaxId
     */
    country: string;
    /**
     * Unix timestamp of when the tax ID was created
     * @type {number}
     * @memberof TaxId
     */
    created: number;
    /**
     * Type of tax ID (e.g. eu_vat, us_ein)
     * @type {string}
     * @memberof TaxId
     */
    type: string;
    /**
     * The tax ID value
     * @type {string}
     * @memberof TaxId
     */
    value: string;
    /**
     * Verification details for the tax ID
     * @type {Verification}
     * @memberof TaxId
     */
    verification: Verification;
}

/**
 * Check if a given object implements the TaxId interface.
 */
export function instanceOfTaxId(value: object): value is TaxId {
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('created' in value) || value['created'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('verification' in value) || value['verification'] === undefined) return false;
    return true;
}

export function TaxIdFromJSON(json: any): TaxId {
    return TaxIdFromJSONTyped(json, false);
}

export function TaxIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaxId {
    if (json == null) {
        return json;
    }
    return {
        
        'country': json['country'],
        'created': json['created'],
        'type': json['type'],
        'value': json['value'],
        'verification': VerificationFromJSON(json['verification']),
    };
}

export function TaxIdToJSON(json: any): TaxId {
    return TaxIdToJSONTyped(json, false);
}

export function TaxIdToJSONTyped(value?: TaxId | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'country': value['country'],
        'created': value['created'],
        'type': value['type'],
        'value': value['value'],
        'verification': VerificationToJSON(value['verification']),
    };
}

